"use client";

import * as React from "react";

import { IRoutingContext } from "./types";

export const RoutingContext: React.Context<IRoutingContext> =
  React.createContext({
    locale: undefined,
    canonicalLocale: "en-US",
    localeCountryUrlPrefix: "",
    robotLocalePrefix: undefined,
    faireDirectBrandAlias: undefined,
    faireDirectBrandToken: undefined,
    faireDirectWidgetToken: undefined,
    Link: undefined,
    useSearchParams: undefined,
    useRouterOrHistory: undefined,
    usePathname: undefined,
    getShouldUseSoftNavigation: undefined,
  } as IRoutingContext);
